import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import { useAuth } from '../../../contexts/AuthContext';

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

const TopbarProfile = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const history = useHistory();

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      history.push('/login');
    }
  };

  // Extract user display name from backend user data first, then fallback to Cognito data
  const displayName = user?.userData?.name
                     || user?.name
                     || user?.username
                     || user?.attributes?.name
                     || user?.attributes?.email
                     || user?.userData?.email
                     || 'User';

  return (
    <div className="topbar__profile">
      <button type="button" className="topbar__avatar" onClick={handleToggleCollapse}>
        <img className="topbar__avatar-img" src={Ava} alt="avatar" />
        <p className="topbar__avatar-name">Hello, {displayName}</p>
        <DownIcon className="topbar__icon" />
      </button>
      {isCollapsed && (
        <button
          type="button"
          aria-label="button collapse"
          className="topbar__back"
          onClick={handleToggleCollapse}
        />
      )}
      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu">
          <TopbarMenuLink title="Account Research" icon="apartment" path="/research/account" openInNewTab />
          <TopbarMenuLink title="Contact Research" icon="user" path="/research/contact" openInNewTab />
          <TopbarMenuLink title="Find Lookalike" icon="layers" path="/find/lookalike" openInNewTab />
          <div className="topbar__menu-divider" />
          <button
            type="button"
            className="topbar__menu-link"
            onClick={handleLogout}
          >
            <span className="topbar__menu-icon lnr lnr-exit" />
            <p className="topbar__menu-link-title">Log Out</p>
          </button>
        </div>
      </Collapse>
    </div>
  );
};

export default TopbarProfile;
